import type { ReactNode } from 'react';

export interface DetailRowProps {
  label: string;
  children: ReactNode;
}

/**
 * One label/value pair inside a `<dl>` on an admin detail drawer - a plain
 * label on the left, the value right-aligned. Promoted out of five identical
 * private `function Row(...)` copies (`UserDetailDrawer.tsx`,
 * `StartupDetailDrawer.tsx`, `AuditDetailDrawer.tsx`, and, as of this fix
 * round, `ApplicationDetailDrawer.tsx` and `PartnerDetailDrawer.tsx`) - per
 * mnr-standards, "anything appearing in 2+ places is a shared component, not
 * copied JSX." The three earlier drawers are left untouched (BP-6); only the
 * two new ones were migrated to this shared version.
 *
 * Domain-free by design: it renders whatever `children` the caller supplies
 * (a plain string, a `Badge`, a formatted date) and knows nothing about any
 * one console's data shape.
 */
export function DetailRow({ label, children }: DetailRowProps) {
  return (
    <div className="flex items-center justify-between gap-4">
      <dt className="text-text-secondary">{label}</dt>
      <dd className="text-right text-text-primary">{children}</dd>
    </div>
  );
}
